import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminChamberService } from '@services/adminChamberService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminChambersIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminChamberService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminChamberService: AdminChamberService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-chambers-new', this.dom, () => {
            this.adminChamberService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminChamberService,
            {
                entityKey: 'chambers',
                fetchData: (params) =>
                    this.adminChamberService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (chamber) => {
                        this.adminChamberService
                            .editDialog(chamber, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminChambersIndexController = app.controller(
    'adminChambersIndexController',
    AdminChambersIndexController,
);
